/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPaymentScheme } from 'app/shared/model/payment-scheme.model';
import { IHospitalProcedure } from 'app/shared/model/hospital-procedure.model';
import { IDentalExamAndTreatment } from 'app/shared/model/dental-exam-and-treatment.model';
import { ProcedurePriceType } from 'app/shared/model/enumerations/procedure-price-type.model';

export interface IProcedurePrice {
  id?: string;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  price?: number;
  discount?: number | null;
  priceType?: keyof typeof ProcedurePriceType | null;
  multiplierApplied?: boolean;
  startDate?: number;
  endDate?: number | null;
  suspended?: boolean;
  draft?: boolean;
  scheme?: IPaymentScheme | null;
  procedure?: IHospitalProcedure;
  exam?: IDentalExamAndTreatment | null;
}

export const defaultValue: Readonly<IProcedurePrice> = {
  active: false,
  multiplierApplied: false,
  suspended: false,
  draft: false,
};
